module.exports = __webpack_public_path__ + "static/img/instore_row4_icon2.c893fe87.png";